export const services = {
  'seo.title': 'Tjenester — Ernæringsstøtteprogrammer | Sofia og Elena',
  'seo.description': 'Velg ditt program: VIP Tandem-støtte, FMD-protokoll for cellulær foryngelse, barneernæring eller gruppeintensiver.',
  'seo.keywords': 'ernæringsfysiolog tjenester, ernæringsprogrammer, VIP støtte, FMD protokoll, barneernæring',

  'hero.title': 'Våre dører',
  'hero.description': 'Hvert program er en inngang til en ny versjon av deg selv. Velg din vei til helse og skjønnhet.',

  'service1.title': 'Personlig VIP-støtte',
  'service1.subtitle': 'Tandem',
  'service1.description': 'Full fordypning. Daglig støtte. Analysegjennomgang, stressarbeid, ernæring for hele familien.',
  'service1.feature1': 'Daglig støtte fra to eksperter',
  'service1.feature2': 'Dyp analysegjennomgang',
  'service1.feature3': 'Arbeid med stress og emosjonell tilstand',
  'service1.feature4': 'Individuelle ernæringsprotokoller',
  'service1.feature5': 'Støtte for hele familien',

  'service2.title': 'FMD-protokoll',
  'service2.subtitle': 'Cellulær foryngelse',
  'service2.description': '5 dager med biohacking. Minus biologisk alder, pluss uendelig energi.',
  'service2.feature1': '5-dagers vitenskapelig protokoll',
  'service2.feature2': 'Cellulær kroppsfornyelse',
  'service2.feature3': 'Reduksjon av biologisk alder',
  'service2.feature4': 'Økt energi og mental klarhet',
  'service2.feature5': 'Avgiftning på cellulært nivå',

  'service3.title': 'Barneernæring',
  'service3.subtitle': 'Fremtiden starter på tallerkenen',
  'service3.description': 'Sunn spiseatferd fra vuggen. Arbeid med allergier, kresen mat og immunitet.',
  'service3.feature1': 'Forming av sunne spisevaner',
  'service3.feature2': 'Arbeid med matallergier',
  'service3.feature3': 'Løsning av kresen mat-problemer',
  'service3.feature4': 'Styrking av immunitet',
  'service3.feature5': 'Vekst- og utviklingsstøtte',

  'service4.title': 'Gruppeintensiver',
  'service4.subtitle': 'Fellesskapsenergi',
  'service4.description': 'Milde protokoller for de som ønsker en rask og kvalitetsstart under vår veiledning.',
  'service4.feature1': 'Arbeid i minigrupper på 3-4 personer',
  'service4.feature2': 'Energi og støtte fra likesinnede',
  'service4.feature3': 'Strukturerte protokoller',
  'service4.feature4': 'Regelmessige gruppesamtaler',
  'service4.feature5': 'Rimelig pris',

  'learnMore': 'Lær mer',
  'learnMoreAria': 'Lær mer om {{service}}',

  'cta.title': 'Vet ikke hva du skal velge?',
  'cta.description': 'Meld deg på en gratis diagnostikk, og vi velger det perfekte programmet for deg',
  'cta.button': 'Bestill diagnostikk',
  'cta.buttonAria': 'Bestill en gratis diagnostikk',
};